import { render, staticRenderFns } from "./app_version_page.vue?vue&type=template&id=24367ec8&scoped=true"
import script from "./app_version_page.vue?vue&type=script&lang=js"
export * from "./app_version_page.vue?vue&type=script&lang=js"
import style0 from "./app_version_page.vue?vue&type=style&index=0&id=24367ec8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24367ec8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24367ec8')) {
      api.createRecord('24367ec8', component.options)
    } else {
      api.reload('24367ec8', component.options)
    }
    module.hot.accept("./app_version_page.vue?vue&type=template&id=24367ec8&scoped=true", function () {
      api.rerender('24367ec8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/record/app_version_page.vue"
export default component.exports